<div>
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
        [updateStatusType]="updateStatusType" [headerTemplate]="headerTemplate" [(isBusy)]="isBusy"
        [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs" [requestInfo]="requestInfo"
        [gridContext]="gridContext" [contextMenuOptions]="contextMenuOptions"
        [hasContextMenuPermissions]="hasContextMenuPermissions">
    </res-generic-grid>
    <ng-template #headerTemplate>
        <div class='parent-header'>
            <span>Delete Pending Projects</span>
        </div>
    </ng-template>
</div>